import React, { useEffect, useState, useRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { onboardingServices } from "../../services/onboardingServices";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { packageServices } from "../../services/packageServices";
import { isEmptyDash, strToDate } from "../../constant";
import { projectServices } from "../../services/projectServices";
import _, { indexOf } from "lodash";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import PackageDocuments from "./packageDocuments";
import BulkUploadModal from "../common/bulkUpload";
import * as XLSX from "xlsx";
import checkImage from "../../assests/images/check-circle.png"; 
import samplePackageFile from "../../assests/document/bulk_package_boq.xlsx";
import BoqDescriptionModal from "../common/boqDescriptionModal"; 
import { UserObj } from "../../services/localStarage";
import { rfqServices } from "../../services/rfqServices";  
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem"; 
import { getSecPermission } from "../../constant";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },

  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const createTableArr1 = [
  { label: "Description", name: "description", value: "Description", options: [], errMsg: "" },
  { label: "HSN/SAC Code", name: "hsnSacCode", value: "HSN/SAC Code", options: [], errMsg: "" },
  { label: "UOM", name: "uom", value: "UOM", options: [], errMsg: "" },
  { label: "Quantity", name: "quantity", value: "Quantity", options: [], errMsg: "" },
];

function PackageCreationForm() {
  let navigate = useNavigate();
  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [openenxcelfileupload, setOpenEnxcelFileUpload] = useState(false);
  const [openCreateEmp, setOpenCreateEmp] = React.useState(false);

  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [fileInput, setFileInput] = useState([]);
  const [fileData, setFileData] = useState(null);
  const isDeleteDisabled = !fileInput;
  const [tableData, setTableData] = useState([{
    // "id": new Date().getTime().toString(),      
    "description": "",
    "hsnSacCode": "",
    "uom": "",
    "quantity": "",
    // "rate": null,
    // "amount": null
  }]);
  const [categoriyList, setCategoriyList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isProjectAvailable, setIsProjectAvailable] = useState(false);
  const [projectCode, setProjectCode] = useState(null);
  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [uploadFilesObj, setUploadFilesObj] = useState({});

  const [createTableArr, setCreateTableArr] = useState(createTableArr1);
  const [openBulkUploadModal, setOpenBulkUploadModal] = React.useState(false);
  const [openDefaulfFields, setOpenDefaulfFields] = React.useState(false);
  const [openPackageUpdatesuccessfully, setOpenPackageUpdateSuccessfully] = useState(false);
  const [createdNewPackageNo, setCreatedNewPackageNo] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalDescription, setModalDescription] = useState("");
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [activeProjectFields, setactiveProjectFields] = useState('');
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const navigateUrl = (param) => {
    navigate(param);
  };
  const [createPackageFieldsDetails, setCreatePackageFieldsDetails] = React.useState({ boqs: [], documents: [] });

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       await getPackageFieldDetails(); // Assuming this is an async function
  //     } catch (error) {
  //       console.error("Error fetching package details:", error);
  //     }
  //   };
    
  //   fetchData();
  // }, []);

  useEffect(() => {
    const url = window.location.href;
    const urlObj = new URL(url);
    const params = urlObj.searchParams;
    const projectCodeParam = params.get('p');
    if (!isEmptyDash(projectCodeParam)) {
      setProjectCode(projectCodeParam);
      getProjectDetails(projectCodeParam);
    }
    else {
      setIsProjectAvailable(false);
      getDocuments();
      
    }

    getCategoryForProjects();
    getDepartmentForProjects();
    // getDocuments();
    getPackageFieldDetails();

  }, []);

  const onsetOpenDefaulfFields = (param) => {
    setOpenDefaulfFields(param);
  };

  const onBulkUploadSubmit = (fileDataParam, createTableArr) => {
    let isAllFieldsMapped = true;
    let updatedTableArr = [...createTableArr];

    // Check if any field in createTableArr is not selected (i.e., value is empty)
    for (let i = 0; i < updatedTableArr.length; i++) {
      if (!updatedTableArr[i].value) {
        updatedTableArr[i].errMsg = "Please select a value from the drop-down"; // Set error message
        isAllFieldsMapped = false;
      } else {
        updatedTableArr[i].errMsg = ""; // Clear error message if value is selected
      }
    }


    if (!isAllFieldsMapped) {
      setCreateTableArr(updatedTableArr);
      openAlert(true, "error", `Please select values from the drop-down for each field.`);
      return;
    }


    let reader = new FileReader();

    reader.onload = function (e) {
      let data = e.target.result;
      data = new Uint8Array(data);
      let workbook = XLSX.read(data, { type: "array" });
      let result = {};
      workbook.SheetNames.forEach(function (sheetName) {
        let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
          defval: "" // Ensure empty cells are represented as empty strings
        });
        if (roa.length) result[sheetName] = roa;
      });

      let arr = [];
      let obj = {};

      // Determine the indices for the columns based on the headers
      for (let i = 0; i < createTableArr.length; i++) {
        let valIndex = result?.Sheet1[0]?.indexOf(createTableArr[i].value);
        let keyName = createTableArr[i].name;
        obj[keyName] = valIndex;
      }

      // Initialize index for processing existing table data
      let existingIndex = 0;
      let updatedTableData = [...tableData];

      // Start from the second row (index 1) of the Excel data
      for (let j = 1; j < result?.Sheet1.length; j++) {
        let row = result.Sheet1[j];

        // Create a new row object from the current row of the file
        let newObj = {};
        for (let key in obj) {
          newObj[key] = row[obj[key]] || ""; // Default to empty string if value is undefined
        }

        // Replace existing blank row or append new row
        if (existingIndex < updatedTableData.length &&
          Object.values(updatedTableData[existingIndex]).every(value => value === "")) {
          updatedTableData[existingIndex] = newObj;
        } else {
          updatedTableData.push(newObj);
        }

        existingIndex++;
      }
      setTableData(updatedTableData);
      setCreateTableArr(createTableArr1);
      onsetOpenDefaulfFields(false);
      // setFileData(file);
    };
    reader.readAsArrayBuffer(fileDataParam);
  };


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const closeMediaListModal = () => {
    setUploadFilesObj({});
    setIsMediaListModalOpen(false);
  };


  const onUploadMedia = (resData, uploadObj, files) => {
    let obj = {
      key: encodeKey(resData?.data?.Key),
      fileName: files?.name,
    };
    uploadObj.response.push(obj);
    setUploadFilesObj(uploadObj);
  };

  const handleClick = (document, index) => { 
    setUploadFilesObj(document);
    setIsMediaListModalOpen(true);
  }
 
  
  const onImport = () => {
    if (fileInput.length < 1) {
      //   openAlert(true, "error", `Please select valid excel file.`);
      return;
    }
    setOpenCreateEmp(false);
    setOpenDefaulfFields(true);
  };
  const handleDelete = () => {
    setFileInput([]);
    setFileData(null);
    document.getElementById("fileInput").value = "";
  };
  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, filters, data }
  ) => {

    if (type === "pagination") {
      setRequestPayload({
        ...requestPayload,
        pageNumber: page,
        pageSize: sizePerPage,
      });
    }
    if (type == "sort") {
      setRequestPayload({
        ...requestPayload,
        sortArray: [sortField, sortOrder],
      });
      // const requestPayload = {
      //   ...this.state.requestPayload,
      //   sortArray: [sortField + "," + sortOrder],
      // };
      // this.getRoleWiseSOList(requestPayload);
      // this.props.getSalesOrderList(requestPayload);
      // this.setState({
      //   sorting: true,
      // })
    }
    if (type == "filter") {
      // const requestPayload = { ...this.state.requestPayload };
      // let secondSearchCriteriaArr = [];
      // // let secondSearchCriteriaArr = Object.keys(filters).map((ele) => {
      // //   let obj = {
      // //     key: ele,
      // //     value: filters[ele].filterVal,
      // //     operation: filters[ele].comparator,
      // //   };
      // //   return obj;
      // // });
    }
  };
  const lastRowRef = useRef(null);
  const handleAddRow = () => {
    const newRow = {
      // "id": new Date().getTime().toString(),      
      "description": "",
      "hsnSacCode": "",
      "uom": "",
      "quantity": "",
      // "rate": null,
      // "amount": null
    };
    setCount(count + 1);
    setTimeout(() => {
      if (lastRowRef.current) {
        lastRowRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
    setTableData([...tableData, newRow]);
  };

  const handleInputChange = (e, row) => {
    const { name, value } = e.target;
    const updatedData = tableData.map((data) =>
      data._id === row._id ? { ...data, [name]: value } : data
    );
    let formStepFieldsDetailsInitial = { ...createPackageFieldsDetails };
    formStepFieldsDetailsInitial.boqs = updatedData;
    setCreatePackageFieldsDetails(formStepFieldsDetailsInitial);
    setTableData(updatedData);
  };


  const getProjectDetails = (param) => {
    projectServices
      .getProjectDetails(param)
      .then((res) => {
        if (res.data.success === true) {
          setIsProjectAvailable(true);
          setCreatePackageFieldsDetails(res.data.data);
          // setPackageDetailCreationlist(res.data.data);
        } else {
          setIsProjectAvailable(false);
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setIsProjectAvailable(false);
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        getDocuments();
        setIsLoading(false);
      });
  }

  const getDepartmentForProjects = (param) => {
    projectServices
      .getDepartmentForProjects()
      .then((res) => {
        if (res.data.success === true) {
          setDepartmentList(res.data.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getCategoryForProjects = (param) => {
    projectServices
      .getCategoryForProjects()
      .then((res) => {
        if (res.data.success === true) {
          setCategoriyList(res.data.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getDocuments = (param) => {
    packageServices
      .getDocuments()
      .then((res) => {
        if (res.data.success === true) {
          // setCategoriyList(res.data.data); 
          setCreatePackageFieldsDetails((prevState) => ({
            ...prevState,
            ["documents"]: res.data.data,
          }));
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }
  const validateTableData = () => {
    for (const row of tableData) {
      if (!row.description || !row.hsnSacCode || !row.uom || !row.quantity) {
        return { valid: false };
      }
    }
    return { valid: true };
  };

  const [buyerAssignee, setBuyerAssignee] = useState(''); 
  const userRole = UserObj?.role?.name;

  const areRequiredDocumentsValid = () => { 
    const requiredDocuments = activeDocument?.[0]?.fields.filter((doc) => doc.required); 
    // console.log(activeDocument);
    for (let doc of requiredDocuments) {
      if (!doc.response || doc.response.length === 0 || !doc.response[0].fileName) {
        return { valid: false, label: doc.name };  
      }
    } 
    return { valid: true };
  };

  

  const transformDocuments = (document) => {
    if (!Array.isArray(document) || !document[0]?.fields) { 
      return [];  
    }
    return document[0].fields.map((field) => ({
      documentName: field.name,
      uniqueName: field.uniqueName,
      response: field.response ? field.response.map((res) => ({
        key: res.key,
        fileName: res.fileName,
        _id: field._id,  
      })) : [],  
      _id: field._id,  
    }));
  };

  
  const submitForm = (param) => {  
    if(createPackageFieldsDetails?.purchaseType === '' || isEmptyDash(createPackageFieldsDetails?.purchaseType)){
      setAlertComponent({ open: true, type: "error", message: "Please Select Purchase Type" });
      return;
    }
    /** Check BOQ */
    const boqValidation = validateTableData();
    if (!boqValidation.valid) {
      setAlertComponent({ open: true, type: "error", message: "Please fill the blank BOQ line item first to proceed" });
      return;
    }
 
    // Check for duplicate items in BOQ
    const uniqueDescriptions = new Set(tableData.map(item => item.description.trim().toLowerCase()));
    if (uniqueDescriptions.size !== tableData.length) {
      setAlertComponent({ open: true, type: "error", message: "Duplicate descriptions found in BOQ. Please ensure all descriptions are unique." });
      return;
    }

    /** Check Document */
    if(!isEmptyDash(activeDocument)){
      const validation = areRequiredDocumentsValid();
      if (!validation.valid) {
        setAlertComponent({ open: true, type: "error", message: `The document "${validation.label}" is blank or invalid.` });
        return;
      } 
    }
    
      const flattenedFields = activeProjectFields.flatMap(project => project.fields || []); 
      const additionalFields = Object.keys(createPackageFieldsDetails)
        .filter((key) => 
          flattenedFields.find((field) => field.uniqueName === key && !field.static)
        ) // Only dynamic fields
        .reduce((obj, key) => {
          obj[key] = createPackageFieldsDetails[key];
          return obj;
        }, {});
 
      const filteredFormData = Object.keys(createPackageFieldsDetails)
        .filter((key) => 
          !flattenedFields.find((field) => field.uniqueName === key && !field.static)
        )  
        .reduce((obj, key) => {
          obj[key] = createPackageFieldsDetails[key];
          return obj;
        }, {});  

    let bodyData = {
      "isSubmitting": param, // true for Created
      "againstProject": isProjectAvailable,
      "packageName": createPackageFieldsDetails?.packageName,
      "packageType": createPackageFieldsDetails?.packageType,
      "remarks": createPackageFieldsDetails?.remarks,
      "categoryId": createPackageFieldsDetails?.categoryId,
      "subcategoryId": createPackageFieldsDetails?.subcategoryId,
      "departmentId": createPackageFieldsDetails?.departmentId,
      "dueDate": createPackageFieldsDetails?.dueDate,
      "purchaseType": createPackageFieldsDetails?.purchaseType,
      "boqs": tableData,
      "documents": transformDocuments(activeDocument),
      "additionalFields": additionalFields,
    //  "buyer":[createPackageFieldsDetails?.assignBuyer]
    }  
    if (createPackageFieldsDetails?.assignBuyer !== '' && createPackageFieldsDetails?.assignBuyer !== undefined) {
      bodyData.buyer = createPackageFieldsDetails?.assignBuyer;
   } 
  // console.log('testingb',bodyData);

    if (isProjectAvailable) {
      bodyData["projectId"] = createPackageFieldsDetails?._id;
    } 
    packageServices
      .packageCreation(bodyData)
      .then((res) => {
        if (res.data.success === true) {
          // setPackageDetailCreationlist(res.data.data);
          setCreatedNewPackageNo(res.data.data.packageCode);
          setOpenPackageUpdateSuccessfully(true);
          // setAlertComponent({ open: true, type: "success", message: `${res.data?.message} `, }); 
          setTimeout(() => {
            navigateUrl(`/admin/Project-Manager-Packages-Listing`);
          }, 3000);
        } else {
          setAlertComponent({ open: true, type: "error", message: `No Data Found `, });
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const columns = [
    {
      dataField: "checkbox",
      text: "Select",
      formatter: (cell, row) => {
        return <input type="checkbox" id={row._id} name="item_id" />;
      },
    },
    {
      dataField: "itemno",
      text: `Item No`,
      sort: true,
      formatter: (cell, row) => {
        return count;
      },
    },
    {
      dataField: "description",
      text: "Description",
      formatter: (cell, row) => {
        return (
          <input
            className="form-control form-haswe"
            type="text"
            placeholder=""
            name="description"
            value={row.description}
            onChange={(e) => handleInputChange(e, row)}
          />
        );
      },
    },
    {
      dataField: "hsnSacCode",
      text: `HSN/SAC Code`,
      formatter: (cell, row) => {
        return <input className="form-control form-haswe" type="text" name="hsnSacCode"
          value={row.hsnSacCode}
          onChange={(e) => handleInputChange(e, row)} />;
      },
    },

    {
      dataField: "uom",
      text: "UOM",
      formatter: (cell, row) => {
        return <input className="form-control form-haswe" type="text" name="uom" value={row.uom}
          onChange={(e) => handleInputChange(e, row)} />;
      },
    },

    {
      dataField: "qty",
      text: "Qty",
      formatter: (cell, row) => {
        return <input className="form-control form-haswe" type="text" name="qty" value={row.qty}
          onChange={(e) => handleInputChange(e, row)} />;
      },
    },
    {
      dataField: "rate",
      text: "Rate in Rupees",
      formatter: (cell, row) => {
        return (
          <input
            className="form-control form-haswe"
            type="text"
            placeholder="0"
            disabled
            name="rate"
            value={row.rate}
            onChange={(e) => handleInputChange(e, row)}
          />
        );
      },
    },

    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <input
            className="form-control form-haswe"
            type="text"
            placeholder="0"
            name="item_amount"
            value={row.amount}
            disabled
          />
        );
      },
    },
    {
      dataField: "text",
      text: "",
      //   formatter: (cell, row) => {
      //     return (
      //       <input
      //         className="form-control form-haswe"
      //         type="text"
      //         placeholder=""
      //         disabled
      //       />
      //     );
      //   },
    },
    {
      dataField: "text1",
      text: "",
      formatter: (cell, row) => {
        return <HighlightOffIcon className="highlight_close_btn" />;
      },
    },

    // {
    //   dataField: "action",
    //   text: "Action",
    //   events: {
    //     onChange: (e, column, columnIndex, row, rowIndex) => {},
    //   },
    //   formatter: (cell, row, rowIndex) => {
    //     return (
    //       <div className="d-flex">
    //         <div className="vendor-action"> View </div>
    //         <div className="vendor-action"> | Edit </div>
    //         <div className="vendor-action"> | Update Status </div>
    //       </div>
    //     );
    //   },
    // },
  ];
  const fileInputRef = useRef([]);
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const uploadFile = (e, document, index) => { 
    e.preventDefault();
    let formData = new FormData();
    let files = e.target.files[0]
    const documentName = e.target?.dataset?.documentname;
    const uniqueName = e.target?.dataset?.uniquename;
    formData.append("file", e.target.files[0]);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {
          setUrl(response?.data?.data, files, document, index);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };

   
  const handleButtonClick = (i) => {
    fileInputRef.current[i].click();
  };
 
  // const onTextChange = (e) => {
  //   const { name, value } = e.target;
  //   setCreatePackageFieldsDetails((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  // };

  const onTextChange = (e, cell, rowIndex, column, packagedetailCreationlistParam) => {
    const { name, value } = e.target;
    let updatedValue = value;
    if (name === 'packageName') {
      updatedValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
    }
    setCreatePackageFieldsDetails((prevState) => ({
      ...prevState,
      // [name]: value,
      [name]: updatedValue,
    }));
  };


  const onFieldChange = (value, secName) => {
    // const { name, value } = e.target;
    if (secName == "categoryId") {
      setCreatePackageFieldsDetails((prevState) => ({
        ...prevState,
        subcategoryId: "",
      }));
      let arr = categoriyList.filter(ele => ele?._id == value);
      setSubCategoryList(arr[0]?.subcategories);
    }
    // if (secName === "dueDate") {
    //   const dateParts = value.split("-");
    //   if (dateParts.length === 3) {
    //     const year = dateParts[0];
    //     if (year.length <= 4 && /^[0-9]{0,4}$/.test(year)) {
    //       updatedValue = value;
    //     } else {
    //       return;
    //     }
    //   }
    // }

    setCreatePackageFieldsDetails((prevState) => ({
      ...prevState,
      [secName]: value,
    }));
  };

  const deleteRow = (id, i) => {
    const updatedRows = tableData.filter((row, idx) => i !== idx);
    setTableData(updatedRows);
  };

  // const handleChange = (id, field, value, i) => {
  //   const tableDataInit = _.cloneDeep(tableData);
  //   tableDataInit[i][field] = value;
  //   setTableData(tableDataInit);
  // };
  const handleChange = (id, key, value, index) => {
    if ((key === "quantity" || key === "hsnSacCode") && Number(value) < 0) {
      return;
    }
    const newData = [...tableData];
    newData[index][key] = value;
    setTableData(newData);
  };
  // const handleEditClick = (row) => { 
  //   setEditRowIndex(rowIndex);
  //   setCurrentRow(row);
  //   setModalDescription(row.description);
  //   setIsModalOpen(true);
  // };

  const handleEditClick = (rowIndex) => {
    setEditRowIndex(rowIndex);
    setModalDescription(tableData[rowIndex].description);
    setIsModalOpen(true);
  };

  const handleModalSubmit = () => {
    if (editRowIndex !== null) {
      const updatedData = [...tableData];
      updatedData[editRowIndex].description = modalDescription;
      setTableData(updatedData);
      setEditRowIndex(null);
      setIsModalOpen(false);
    }
  };

  // const today = new Date().toISOString().split('T')[0];
  // const maxDate = new Date();
  // maxDate.setFullYear(maxDate.getFullYear() + 5);
  // const maxDateStr = maxDate.toISOString().split('T')[0];



  const[activeDocument, setActiveDocument] = useState('');
  const[activefields, setActiveFields] = useState('');
  const getPackageFieldDetails = () => {
    setIsLoading(true); 
    packageServices
      .getPackageFieldList('BIDDING','PACKAGE')
      .then((res) => { 
        if (res.data.success === true) { 
          const filteredDocument = res.data?.data?.sections.filter(section => { 
            return section.title === "Documents";
          });
          const filteredFields = res.data?.data?.sections.filter(section => { 
            return section.title === "Fields";
          });
          setActiveFields(filteredFields);
          setActiveDocument(filteredDocument);
          setactiveProjectFields( res.data?.data?.sections);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message} `,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };  
 
// const setUrl = (data, files, document, index) => {
  //   console.log('seturl',data,files,document,index)
  //   let createPackageFieldsDetailsInitial = { ...createPackageFieldsDetails };
  //   for (let i = 0; i < createPackageFieldsDetailsInitial?.documents.length; i++) {
  //     if (createPackageFieldsDetailsInitial?.documents[i]?.uniqueName == document?.uniqueName) {
  //       let fileObj = {
  //         key: encodeKey(data?.data?.Key),
  //         fileName: files?.name
  //       };
  //       createPackageFieldsDetailsInitial?.documents[i]?.response.push(fileObj);
  //     }
  //   }
  //   setCreatePackageFieldsDetails(createPackageFieldsDetailsInitial);
  // };

  const setUrl = (data, files, document, index) => {      
    let activeDocumentInitial = _.cloneDeep(activeDocument);  
    if (activeDocumentInitial[0]?.fields?.length) {
        for (let i = 0; i < activeDocumentInitial[0]?.fields?.length; i++) { 
            if (activeDocumentInitial[0]?.fields[i]?.uniqueName === document) {                 
              activeDocumentInitial[0].fields[i].response = 
                    activeDocumentInitial[0].fields[i].response || [];
                let fileObj = {
                    key: encodeKey(data?.data?.Key),
                    fileName: files?.name
                };
                activeDocumentInitial[0].fields[i].response.push(fileObj); 
            }
        }
    } else {
         
    }  
    setActiveDocument(activeDocumentInitial); 
}; 
const deleteFile = (index, key, idx) => {
  if (!uploadFilesObj?.response || index < 0 || index >= uploadFilesObj.response.length) {
    console.error('Invalid index or response array.');
    return;
  } 
  const updatedFiles = uploadFilesObj.response.filter((_, i) => i !== index); 
  setActiveDocument(prevState => {
    const updatedState = _.cloneDeep(prevState);  
    if (Array.isArray(updatedState[0]?.fields)) {
      for (let i = 0; i < updatedState[0].fields.length; i++) {
        if (updatedState[0].fields[i]?.uniqueName === uploadFilesObj?.uniqueName) {
          if (Array.isArray(updatedState[0].fields[i].response)) {
            updatedState[0].fields[i].response = updatedFiles;
          } else {
            updatedState[0].fields[i].response = [];
          }
          break;
        }
      }
    }

    return updatedState;
  });

  setUploadFilesObj(prev => ({
    ...prev,
    response: updatedFiles,
  })); 

};
// const deleteFile = (index, key, idx) => {
//   const createPackageFieldsDetailsInit = _.cloneDeep(createPackageFieldsDetails);

//   console.log('activeDocument',activeDocument,createPackageFieldsDetailsInit)
//   const updatedFiles = uploadFilesObj.response.filter((file, i) => i !== index);

//   for (let i = 0; i < createPackageFieldsDetailsInit.documents.length; i++) {
//     if (createPackageFieldsDetailsInit.documents[i].uniqueName == uploadFilesObj?.uniqueName) {
//       createPackageFieldsDetailsInit.documents[i].response = [...updatedFiles];
//     }
//   }
//   setCreatePackageFieldsDetails(createPackageFieldsDetailsInit);
//   const obj = { ...uploadFilesObj, response: [...updatedFiles] };
//   setUploadFilesObj(obj);
// };


useEffect(() => { 
  if (userRole != "VENDOR") {
    getBuyerEngineer(); 
  }
}, []);

const getBuyerEngineer = () => {
  setIsLoading(true);
  let param = "?roles=BUYER&departments=PROCUREMENT";
  rfqServices
    .getAssignEngineer(param)
    .then((res) => {
      if (res && res.data) {
        setBuyerAssignee(res?.data?.data?.assignees);
      } else {
        setAlertComponent({
          open: true,
          type: 'error',
          message: 'No Data Found',
        });
      }
    })
    .catch((error) => {
      setAlertComponent({
        open: true,
        type: 'error',
        message: `${error?.response?.data?.message}`,
      }); 
    })
    .finally(() => {
      setIsLoading(false);
    });
};
const [selectedBuyers, setSelectedBuyers] = React.useState([]);
const handleBuyerChange = (event) => {
  const { value } = event.target;
  setSelectedBuyers(value);  
  onFieldChange(value, "assignBuyer");  
};

const [secEditAssignBuyerPermission, setSecEditAssignBuyerPermission] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });

  useEffect(() => {   
      let permissionAssignBuyerObj = getSecPermission("ASSIGN_BUYER","PACKAGE_DETAILS");     
      setSecEditAssignBuyerPermission(permissionAssignBuyerObj); 
    }, []);

  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_main">
              <h5>Package Creation Form</h5>
            </div>
            { secEditAssignBuyerPermission?.read === true &&
            <div className="">
              <div className="package_creation_form_boq_type_body lets_select_sme">
                  <p><b>  Assign Buyer</b> </p> 
                  <FormControl className="seclected_form_detaila d-flex">
                  <Select
                    multiple
                     className="form-select_sectionpackage seclected_form_detail1ses2"
                    value={selectedBuyers}
                    onChange={handleBuyerChange}
                    displayEmpty
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <em>Select a Buyer</em>; // Placeholder text
                      }
                      const selectedNames = selected.map((id) => {
                        const buyer = buyerAssignee.find((b) => b._id === id);
                        return buyer ? buyer.name : id;
                      });
                      return selectedNames.join(", ");
                    }}
                    placeholder="Select a Buyer"
                  >
                    {/* Placeholder Option */}
                    <MenuItem disabled value="">
                      <em>Select a Buyer</em>
                    </MenuItem>

                    {Array.isArray(buyerAssignee) &&
                      buyerAssignee.map((data) => (
                        <MenuItem key={data._id} value={data._id}>
                          <Checkbox checked={selectedBuyers.indexOf(data._id) > -1} />
                          <ListItemText primary={data.name} />
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>


                  {/* <select
                    id="assignEngineer"
                    className="form-select seclected_form_detaila"
                    aria-label="Default select example"
                    fdprocessedid="2t62w" 
                    onChange={(e) => onFieldChange(e.target.value,"assignBuyer")}
                    name="assignBuyer"
                  >
                    <option value="">Select Buyer</option> 
                    {Array.isArray(buyerAssignee) && buyerAssignee?.map((data, index) => (
                      <option key={index} value={data._id}>{data.name}</option>
                    ))}
                  </select> */}


              </div> 
            </div>
            }

          </div>
          <div class="listing_project_block_mainsection1">
            { (isProjectAvailable == true) && 
              <>
                <div class="listing_project_block_2">
                  <div class="listing_project_block_3">
                    <p>
                      <b>Project Code:</b>
                    </p>
                    <p class="block_detail_listing">{createPackageFieldsDetails?.projectCode}</p>
                  </div>
                </div>
                <div class="listing_project_block_2">
                  <div class="listing_project_block_3">
                    <p>
                      <b>Project Site Code:</b>
                    </p>
                    <p class="block_detail_listing">{createPackageFieldsDetails?.projectCode}</p>
                  </div>
                </div>
                <div class="listing_project_block_2">
                  <div class="listing_project_block_3">
                    <p>
                      <b>Project Name:</b>
                    </p>
                    <p class="block_detail_listing">{createPackageFieldsDetails?.projectName}</p>
                  </div>
                </div> 
                {createPackageFieldsDetails?.COD !== '' || createPackageFieldsDetails?.COD === undefined &&(
                  <div class="listing_project_block_2">
                    <div class="listing_project_block_3">
                      <p>
                        <b>COD:</b>
                      </p>
                      <p class="block_detail_listing">{strToDate(createPackageFieldsDetails?.COD)}</p>
                    </div>
                  </div>
                  )}
                {createPackageFieldsDetails?.location !== '' &&(
                  <div class="listing_project_block_2">
                    <div class="listing_project_block_3">
                      <p>
                        <b>Project Location:</b>
                      </p>
                      <p class="block_detail_listing">{createPackageFieldsDetails?.location}</p>
                    </div>
                  </div>
                )}
                {createPackageFieldsDetails?.capacity !== '' &&(
                <div class="listing_project_block_2">
                  <div class="listing_project_block_3">
                    <p>
                      <b>Capacity:</b>
                    </p>
                    <p class="block_detail_listing">{createPackageFieldsDetails?.capacity}</p>
                  </div>
                </div>
                )}
                <div class="listing_project_block_2">
                  <div class="listing_project_block_3">
                    <p>
                      <b>Created by:</b>
                    </p>
                    <p class="block_detail_listing">Avaada</p>
                  </div>
                </div>
                </>
              }
          <div class="listing_project_block_2_1">
              <div class="listing_project_block_3">
                <p>
                  <b>Package Name:<span className="required">*</span></b>
                </p>
                <input
                  class="form-control form-haswes"
                  type="text"
                  fdprocessedid="u2nmq"
                  name="packageName"
                  value={createPackageFieldsDetails.packageName}
                  onChange={(e) => onTextChange(e)}
                />
              </div>
            </div>
            <div class="listing_project_block_2_1">
              <div class="listing_project_block_3">
                <p>
                  <b>Category:<span className="required">*</span></b>
                </p>
                <select
                  class="form-select package_creation_form_detail"
                  aria-label="Default select example"
                  fdprocessedid="zlera"
                  name="categoryId"
                  value={createPackageFieldsDetails.categoryId}
                  onChange={(e) => onFieldChange(e.target.value, "categoryId")}
                >
                  <option value="" >
                    Please Select
                  </option>
                  {categoriyList.map((optionData, j) => (
                    <>
                      <option value={optionData?._id} key={j}>
                        {optionData?.categoryName}
                      </option>
                    </>
                  ))}
                </select>{" "}
              </div>
            </div>
            <div class="listing_project_block_2_1">
              <div class="listing_project_block_3">
                <p>
                  <b>Sub-Category:<span className="required">*</span></b>
                </p>
                <select
                  class="form-select package_creation_form_detail"
                  aria-label="Default select example"
                  fdprocessedid="zlera"
                  name="subcategoryId"
                  value={createPackageFieldsDetails.subcategoryId}
                  onChange={(e) => onFieldChange(e.target.value, "subcategoryId")}
                >
                  <option value="" >
                    Please Select
                  </option>
                  {subCategoryList.map((optionData, j) => (
                    <>
                      <option value={optionData?._id}>
                        {optionData?.subCategoryName}
                      </option>
                    </>
                  ))}
                </select>{" "}
              </div>
            </div>
            <div class="listing_project_block_2_1">
              <div class="listing_project_block_3">
                <p>
                  <b>Department:<span className="required">*</span></b>
                </p>
                <select
                  class="form-select package_creation_form_detail"
                  aria-label="Default select example"
                  fdprocessedid="zlera"
                  name="departmentId"
                  value={createPackageFieldsDetails.departmentId}
                  onChange={(e) => onFieldChange(e.target.value, "departmentId")}
                >
                  <option value="" >
                    Please Select
                  </option>
                  {departmentList.map((optionData, j) => (
                    <>
                      <option value={optionData?._id} key={j}>
                        {optionData?.departmentName}
                      </option>
                    </>
                  ))}
                </select>{" "}
              </div>
            </div> 

           
        </div>
        <div class="listing_project_block_mainsection1" style={{marginTop:"20px"}}> 
            { Array.isArray(activefields) && activefields[0]?.fields?.map((ele, i) => (
              <>  
                  {ele.uniqueName === "packageType" && ele.display === true && (
                     <div class="listing_project_block_2_1">
                        <div class="listing_project_block_3">
                        <p>
                          <b> {ele.name}{ele?.required && <span className="required">*</span>}:</b>
                        </p>
                        {ele.type === "Dropdown" && ele.options?.length > 0 && (
                          <select
                            className="form-select package_creation_form_detail"
                            aria-label="Default select example"
                            name={ele.uniqueName}
                            value={createPackageFieldsDetails[ele.uniqueName] || ""}
                            onChange={(e) => onFieldChange(e.target.value, ele.uniqueName)}
                          >
                            <option>Select</option> 
                            {ele.options.map((option, optionIndex) => (
                              !option.isDeleted && (
                                <option key={option._id} value={option.optionName}>
                                  {option.optionName}
                                </option>
                              )
                            ))}
                          </select>
                        )}
                        </div>
                    </div>
                  )} 
                  {ele.display === true  && ele?.static === false  && (
                        <div key={i} className="listing_project_block_2_1">
                          <div className="listing_project_block_3">
                            <p>
                              <b>
                                {ele?.name} {ele?.required && <span className="required">*</span>}:
                              </b>
                            </p>

                            {/* Handle String Type Fields (Non-static and Required) */}
                            {ele.type === "String" && (
                              <input
                                className="form-control form-haswes"
                                type="text"
                                placeholder={`Enter ${ele?.name}`}
                                name={ele.uniqueName}
                                value={createPackageFieldsDetails[ele.uniqueName] || ''}
                                // onChange={handleChange}
                                onChange={(e) => onFieldChange(e.target.value, ele.uniqueName)}
                              />
                            )}

                            {/* Handle Dropdown Type Fields */}
                            {ele.type === "Dropdown" && ele.options?.length > 0 && (
                              <select
                                className="form-select package_creation_form_detail"
                                aria-label="Default select example"
                                name={ele.uniqueName}
                                value={createPackageFieldsDetails[ele.uniqueName] || ""}
                                onChange={(e) => onFieldChange(e.target.value, ele.uniqueName)}
                              >
                                <option>Select</option>
                                {ele.options.map((option) => (
                                  !option.isDeleted && (
                                    <option key={option._id} value={option.optionName}>
                                      {option.optionName}
                                    </option>
                                  )
                                ))}
                              </select>
                            )}
                            {/* Handle Number Type Fields */}
                            {ele.type === "Number" && (
                              <input
                                className="form-control form-haswes"
                                type="number"
                                placeholder={`Enter ${ele?.name}`}
                                name={ele.uniqueName}
                                value={createPackageFieldsDetails[ele.uniqueName] || ""}
                                onChange={(e) => onFieldChange(e.target.value, ele.uniqueName)}
                                min="0"  // Optional: Can add other validation like max, step
                                required={ele.required}
                              />
                            )}
                          </div>
                        </div>
                    )}  
                  </>
             ))}  
             <div class="listing_project_block_2_1">
              <div class="listing_project_block_3">
                <p>
                  <b>Package Date:</b>
                </p>
                <p class="block_detail_listing">{strToDate(Number(new Date()))}</p>
              </div>
            </div>
          </div>




          <div class="search_filter_outers ms-auto">
              { Array.isArray(activefields) && activefields[0]?.fields?.map((ele, i) => (
                  <> 
                      {ele.uniqueName === "purchaseType" && ele.display === true && (
                        <div class="seclected_form_detail_firstes">
                            <div class="package_creation_form_boq_type_body">
                            <h5 className="lets_boq_outer">BOQ</h5>
                            <p>
                              <b> {ele.name} {ele?.required && <span className="required">*</span>}</b>
                            </p>
                            {ele.type === "Dropdown" && ele.options?.length > 0 && (
                              <select
                                className="form-select seclected_form_detaila"
                                aria-label="Default select example"
                                name={ele.uniqueName}
                                value={createPackageFieldsDetails.purchaseType}
                                onChange={(e) => onFieldChange(e.target.value, "purchaseType")}
                              >
                                <option>Select</option> 
                                {ele.options.map((option, optionIndex) => (
                                  !option.isDeleted && (
                                    <option key={option._id} value={option.optionName}>
                                      {option.optionName}
                                    </option>
                                  )
                                ))}
                              </select>
                            )}
                            </div>
                        </div>
                      )} 
                </>
              ))}  
            <div class="create_listing_projects">
              <button
                // onClick={() => {
                //   setOpenEnxcelFileUpload(true);
                // }}
                onClick={() => setOpenBulkUploadModal(true)}
                className="gate_btn_lr_creations"
              >
                Excel Upload
              </button>
            </div>
          </div>
          <div className="listing_main listing_main_dragdropcontext_body listingmain">
          <table className="">
          <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                <tr>
                  <th><input type="checkbox" /></th>
                  <th className="vendor_tabels">Item No</th>
                  <th className="vendor_tabels">Description</th>
                  <th className="vendor_tabels">HSN/SAC Code</th>
                  <th className="vendor_tabels">UOM</th>
                  <th className="vendor_tabels">Quantity</th>
                  <th className="vendor_tabels">Rate (in INR)</th>
                  <th className="vendor_tabels">Amount (In INR)</th>
                  <th className="vendor_tabels">Actions</th>
                </tr>
              </thead>
              <tbody style={{ overflowY: "scroll", width: "200px" }}>
                {tableData.length < 1 && <>
                  <tr className="maine_tr_vendor">
                    <td colSpan={9} className="text-center">No Data Found</td>
                  </tr>
                </>}
                {tableData.map((row, i) => (
                  <tr key={row.id} className="maine_tr_vendor" ref={i === tableData.length - 1 ? lastRowRef : null}>
                    <td><input type="checkbox" /></td>
                    <td>{i + 1}</td>
                    <td>
                      <div className="custom_main_row_feactures">
                        <div id="custom-search-input" style={{ padding: '0px' }}>
                          <div className="input-group col-md-12">
                            <input
                              className="form-control input-lg"
                              type="text"
                              placeholder=""
                              value={row.description}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value.length <= 350) {
                                  handleChange(row.id, "description", value, i);
                                }
                              }}
                              maxLength="350"
                            />
                            <span className="input-group-btn">
                              <button
                                className="btn btn-info btn-lg"
                                type="button"
                                fdprocessedid="trsp06"
                                onClick={() => handleEditClick(i)}
                              >
                                <span className="glyphicon glyphicon-search">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-pencil"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.146 0.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 3L3 11.207V13h1.793L13 4.793 11.207 3zM1 13.5V15h1.5l.896-.447-2-2L1 13.5z" />
                                  </svg>
                                </span>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        placeholder=""
                        value={row.hsnSacCode}
                        onChange={(e) => {
                          if (e.target.value.length <= 10) {
                            handleChange(row.id, "hsnSacCode", e.target.value, i);
                          }
                        }}
                        // onKeyDown={(e) => {
                        //   if (["e", "E", "+", "-", "."].includes(e.key)) {
                        //     e.preventDefault();
                        //   }
                        // }}
                        maxLength="10"
                        pattern="\d*"
                      />
                    </td>
                    <td>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        placeholder=""
                        value={row.uom}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 20) {
                            handleChange(row.id, "uom", value, i);
                          }
                        }}
                        // onBlur={(e) => {
                        //   const value = e.target.value;
                        //   if (value.length < 15) {
                        //     openAlert(true, "error", `Please Enter  UOM at least 15 to 20 characters.`);
                        //     handleChange(row.id, "uom", "", i);
                        //     return;
                        //   }
                        // }}
                        maxLength="20"
                      />
                    </td>
                    <td>
                      <input
                        className="form-control form-haswe"
                        type="number"
                        placeholder=""
                        value={row.quantity}
                        onChange={(e) =>
                          handleChange(row.id, "quantity", e.target.value, i)
                        }
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-", "."].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}

                      />
                    </td>
                    <td>
                      <input
                        className="form-control form-haswe"
                        type="text"
                        placeholder=""
                        value={row.rate}
                        onChange={(e) => handleChange(row.id, 'rate', e.target.value, i)}
                        disabled
                      />
                    </td>
                    <td className="lets_package_detail_input_div_react_haswe">
                      <input
                        className="form-control form-haswe"
                        type="text"
                        placeholder=""
                        value={row.amount}
                        onChange={(e) => handleChange(row.id, 'amount', e.target.value, i)}
                        disabled
                      />
                    </td>
                    <td>
                      {tableData.length > 1 && (
                        <HighlightOffIcon className="highlight_close_btn" onClick={() => deleteRow(row.id, i)} />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            <button
              className="lets_add_row_react_btn_packagedetail1"
              tabindex="0"
              type="button"
              fdprocessedid="9un26w"
              onClick={handleAddRow}
            >
              <AddIcon /> Add Row
              <span class="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
            </button>
          </div>
          <div>
            <label>Remarks</label>
            <input className="form-control form-hasw" type="text" name="remarks" onChange={(e) => onTextChange(e)} />
          </div>
 
                <div className="listing_block_maine_allbtn">
                  <div className="package_detail_allbtn_projectmanager">   
                    {Array.isArray(activeDocument) &&  activeDocument[0]?.fields?.map((field, index) => (
                        field.type === "File" && field.display === true && (
                          <div key={field._id}>
                            <p className="package_projectmanager">
                              {field.name} {field.required && <span className="required">*</span>}
                            </p> 
                            {/* Check if file is uploaded */}
                            {Array.isArray(field.response) && field.response.length > 0 ? (
                              <>
                                <div className="selected-file-present-div" style={{ display: 'inline' }}>
                                  <span className="selected-file-present-text">
                                  Document: {field.response.length}
                                  </span>
                                </div>
                                <button
                                  className="file-upload-btn"
                                  onClick={() => handleClick(field, index)}
                                >
                                  View
                                </button>
                              </>
                            ) : (
                              // Render file upload button if no file is uploaded
                              <div className="lets_block_package_listing_bom_file" style={{ display: 'block' }}>
                                <button
                                  className="upload_file_bom_tendor_project_react"
                                  onClick={() => handleButtonClick(index)}
                                >
                                  <CloudUploadIcon className="download_icon_react" />
                                  Upload File
                                </button>
                                <input
                                  type="file"
                                  ref={(element) => fileInputRef.current[index] = element}
                                  id={`ref${index}`}
                                  style={{ display: "none" }}
                                  onChange={(e) => uploadFile(e, field.uniqueName, index)}
                                />
                              </div>
                            )}
                          </div>
                        )
                      ))}
                  </div>
                </div> 

          {/* <div class="listing_block_maine_allbtn">
            <div className="package_detail_allbtn_projectmanager">
              {createPackageFieldsDetails?.documents && createPackageFieldsDetails.documents.map((document, index) => (
                <>
                  <div>
                    <p className="package_projectmanager">{document.documentName}
                      
                    </p>
                    {(Array.isArray(document.response) && !isEmptyDash(document.response[0]?.key)) && <>
                      <div className="selected-file-present-div" style={{ display: 'inline' }}>{ }
                        <span className="selected-file-present-text">Document: {document?.response?.length} </span>
                      </div>
                      <button className="file-upload-btn" disabled=""
                        onClick={() => handleClick(document, index)}
                      >View</button>
                    </>
                    }

                    {(!Array.isArray(document.response) || isEmptyDash(document.response[0]?.key)) && <>
                      <div className="lets_block_package_listing_bom_file" 
                      // style={isEmptyDash(document.response[0]?.key) ? { display: 'block' } : { display: 'none' }}
                      style={{ display: 'block' }}
                      >
                        <div>
                          <button className="upload_file_bom_tendor_project_react"
                            onClick={() => handleButtonClick(index)}
                          // htmlFor={`ref${index}`}
                          >
                            <CloudUploadIcon className="download_icon_react" />
                            Upload File
                          </button>
                          <input
                            type="file"
                            // ref={fileInputRef}
                            ref={(element) => fileInputRef.current[index] = element}
                            id={`ref${index}`}
                            style={{ display: "none" }}
                            onChange={(e) => uploadFile(e, document, index)}
                          /> 
                        </div>
                
                      </div>
                    </>}
                  </div>
                </>
              ))}
            </div>
          </div> */}
          <div class="closebtn_submit_block_btn">
            <button
              type="button"
              class="btn btn-success save_next_btns"
              fdprocessedid="cn5f6"
              onClick={() => submitForm(false)}
            >
              Save as Draft
            </button>
            <button
              type="button"
              class="btn btn-success save_next_btns"
              fdprocessedid="cn5f6"
              onClick={() => submitForm(true)}
            >
              Submit
            </button>
          </div>

          {isModalOpen && (
            <BoqDescriptionModal
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              handleModalSubmit={handleModalSubmit}
              setModalDescription={setModalDescription}
              modalDescription={modalDescription}
              title="Add Description"
            />
          )}
          {/* Excel File Upload */}
          <Modal
            open={openenxcelfileupload}
            onClose={() => setOpenEnxcelFileUpload(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employee">
              <div className="modal-header">
                <h5 className="modal-titles" id="uploadexcelfileLabel">
                  Excel File Upload
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setOpenEnxcelFileUpload(false)}
                ></button>
              </div>
              <div className="modal-body lets_modal_body_block_listing">
                <div id="vendorForm">
                  <div className="lets_modal_vendor2">
                    <p>Upload Excel Template</p>
                    <div className="master_panel_icon_react">
                      <input
                        className="form-control form-h choose"
                        type="file"
                        id="fileInput"
                        accept=".xlsx, .xls"
                      />
                      <DeleteIcon
                        className={`delete_icon_btn_panel_react ${isDeleteDisabled ? "disabled" : ""
                          }`}
                        style={{ color: isDeleteDisabled ? "grey" : "red" }}
                        onClick={handleDelete}
                        disabled={isDeleteDisabled}
                      />
                    </div>
                    <div className="clear_btn_status">
                      <button
                        type="button"
                        class="btn clear_btn_status_block_lists"
                        fdprocessedid="wshspp"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-success save_next_btns"
                        fdprocessedid="cn5f6"
                        style={{ color: isDeleteDisabled ? "grey" : "red" }}
                        disabled={isDeleteDisabled}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={openPackageUpdatesuccessfully}
            onClose={() => setOpenPackageUpdateSuccessfully(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Submit Package
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => navigateUrl(`/admin/Project-Manager-Packages-Listing`)}
                ></button>
              </div>
              <div class="modal-bodys">
                <div>
                  <img src={checkImage} alt="" />
                </div>
                <p>
                  New Package has been Created successfully
                  <br />
                  Package No. {createdNewPackageNo}
                </p>
                <button
                  type="button"
                  class="btn btn-success"
                  onClick={() => navigateUrl(`/admin/Project-Manager-Packages-Listing`)}
                >
                  Done
                  {/* <Link
                    to="/admin/Engineering-Bidding-Rfq-Listing"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    Done
                  </Link> */}
                </button>
              </div>
            </Box>
          </Modal>

          <BulkUploadModal
            createTableArr={createTableArr}
            openBulkUploadModal={openBulkUploadModal}
            setOpenBulkUploadModal={setOpenBulkUploadModal}
            onBulkUploadSubmit={onBulkUploadSubmit}
            onsetOpenDefaulfFields={onsetOpenDefaulfFields}
            openDefaulfFields={openDefaulfFields}
            sampleProjectFile={samplePackageFile}
            title="Create BOQ (Upload Excel File)"
          /> 
          <PackageDocuments
            isMediaListModalOpen={isMediaListModalOpen}
            closeMediaListModal={closeMediaListModal}
            uploadObj={uploadFilesObj}
            onUploadMedia={onUploadMedia}
            deleteFile={deleteFile}
            isSubmitCondition={false}
            multiupload={true}
            userDeletefile={true}
            editStatus={true}
          />
        </div>
      </div >

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default PackageCreationForm;
